import { ANIMATION, IS_STICKY } from '../constants';
import isElementInViewport from '../helpers/is-element-in-viewport';

export const stickyButtons = (ctaSelector: string, stickyBtnSelector: string): void => {
    const checkStickyBehavior = (): void => {
        const ctaElement = document.querySelector<HTMLElement>(ctaSelector);
        const stickyBtnsElement = document.querySelector<HTMLElement>(stickyBtnSelector);
        let isAnimating = false;

        if (!ctaElement || !stickyBtnsElement) {
            return;
        }

        if (isElementInViewport(ctaElement)) {
            if (stickyBtnsElement.classList.contains(IS_STICKY) && !isAnimating) {
                isAnimating = true;
                stickyBtnsElement.classList.remove(ANIMATION.FADE_IN_FAST);
                stickyBtnsElement.classList.add(ANIMATION.FADE_OUT_FAST);

                stickyBtnsElement.addEventListener(
                    'animationend',
                    function removeSticky() {
                        stickyBtnsElement.classList.remove(IS_STICKY);
                        isAnimating = false;
                        stickyBtnsElement.removeEventListener('animationend', removeSticky);
                    },
                    { once: true },
                );
            }
        } else {
            if (!stickyBtnsElement.classList.contains(IS_STICKY) && !isAnimating) {
                stickyBtnsElement.classList.add(ANIMATION.FADE_IN_FAST, IS_STICKY);
                stickyBtnsElement.classList.remove(ANIMATION.FADE_OUT_FAST);
            }
        }
    };

    const onScroll = (): void => {
        let ticking = false;

        if (!ticking) {
            window.requestAnimationFrame(() => {
                checkStickyBehavior();
                ticking = false;
            });
            ticking = true;
        }
    };

    window.addEventListener('scroll', onScroll);
    window.addEventListener('resize', onScroll);

    checkStickyBehavior();
};
